import PropTypes from "prop-types";
import classes from "./PageContainer.module.css";

const PageContainer = ({ children }) => {
    return <div className={classes.pageContainer}>{children}</div>;
};

export default PageContainer;

PageContainer.propTypes = {
    children: PropTypes.node,
};
